<template>
    <div id="casBenefitPage">
        <nav class="bar bar-nav home-bar-nav">
            <div class="icon pull-left open-panel" data-panel="#panel-left-demo" @click="goBack">
                <img src="https://resource.rcclchina.com.cn/cas/leftalllow.png" alt="" style="vertical-align: initial;">
                <span class="nav-title">会员权益</span>
            </div>
            <h3 class="title"><img src="https://resource.rcclchina.com.cn/logo/MB/logoAnchorWhite.png" alt="" onclick="location.href='/'"></h3>

            <div class="right-icon">
                <a class="icon pull-right external livechat_online" id="livechat_online" @click="showOnlineService">
                    <img src="https://resource.rcclchina.com.cn/cas/livechat_home.png">
                </a>
                <a class="icon external" href="tel:400-820-7293" mce_href="tel:400-820-7293">
                    <img src="https://resource.rcclchina.com.cn/tui2/06--shape%402x.png" alt="">
                </a>
                <router-link class="icon external faqIcon" to="/content/faq">
                    <img src="https://resource.rcclchina.com.cn/tui2/faqIcon.png" alt="">
                </router-link>
            </div>
        </nav>
        <div class="page-content  noScroll">
            <div class="memberBenefit scroll-container infinite-scroll js-smartScroll">
                <!--不是会员-->
                <div class="cas-header" v-if="casId===''">
                    <div class="cas-notmember">
                        <div>您当前还不是皇冠铁锚俱乐部会员
                            <a href="/Rccl.UserCenter/CustomerInfo/BindLoyalty?returnUrl=/Rccl.UserCenter/Cas/Index" class="external">点击绑定</a></div>
                    </div>
                </div>
                <div class="cas-header" v-else>
                    <div class="cas-code">里程号：{{casId}}</div>
                    <div class="cas-grade">当前级别：{{memberTitle}}&nbsp;&nbsp;|&nbsp;&nbsp;当前里程：{{casCredit}}</div>
                </div>
                <div class="level-box" v-if="isShowVipTab">
                    <div class="level-tab">
                        <div class="level-tab-cell" :class="{ active: currentLevel == 1}" @click="currentLevel=1">
                            <img src="https://resource.rcclchina.com.cn/cas/level01.png" alt="黄金会员" class="">
                            <div class="level-tab-txt">黄金会员</div>
                        </div>
                        <div class="level-tab-cell " :class="{ active: currentLevel == 2}" @click="currentLevel=2">
                            <img src="https://resource.rcclchina.com.cn/cas/level02.png" alt="白金会员" class="">
                            <div class="level-tab-txt">白金会员</div>
                        </div>
                        <div class="level-tab-cell " :class="{ active: currentLevel == 3}" @click="currentLevel=3">
                            <img src="https://resource.rcclchina.com.cn/cas/level03.png" alt="翡翠会员" class="">
                            <div class="level-tab-txt">翡翠会员</div>
                        </div>
                        <div class="level-tab-cell " :class="{ active: currentLevel == 4}" @click="currentLevel=4">
                            <img src="https://resource.rcclchina.com.cn/cas/level04.png" alt="钻石会员" class="">
                            <div class="level-tab-txt">钻石会员</div>
                        </div>
                        <div class="level-tab-cell " :class="{ active: currentLevel == 5}" @click="currentLevel=5">
                            <img src="https://resource.rcclchina.com.cn/cas/level05.png" alt="超级钻石会员" class="">
                            <div class="level-tab-txt">超级钻石会员</div>
                        </div>
                        <div class="level-tab-cell " :class="{ active: currentLevel == 6}" @click="currentLevel=6">
                            <img src="https://resource.rcclchina.com.cn/cas/level06.png" alt="尖峰俱乐部会员" class="">
                            <div class="level-tab-txt">尖峰俱乐部会员</div>
                        </div>
                    </div>
                </div>
                <div class="benefit-m" v-if="isShowVipTab">
                    <div class="benefit-m-box">
                        <div class="benefit-m-header Welcome_On_Board_js" :class="{ active: openMenu[0]}" @click="changeOpenMenu(0)">
                            <div class="benefit-m-txt">船上礼遇</div>
                            <div class="benefit-m-arrow"></div>
                        </div>
                        <div class="benefit-m-table-box scroll-container infinite-scroll js-smartScroll" :style="menuHeight(0)">
                            <div class="benefit-m-table">
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">会员专享的船上优惠 <br>（视等级而不同）</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">SeaPass® 船卡身份识别</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">优先办理Check-in <sup>1</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">专用离船等候室及欧陆式早餐</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">高级会员专属酒会</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">船上专用浴袍 <sup>3</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">纪念徽章</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">欢迎点心和饮品 <sup>5</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">里程嘉奖 <sup>4</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">厨师推荐礼品/用品</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">
                                        <div>岸上观光/Vitality<span class="sup">SM</span>水疗服务优先等候</div>
                                    </div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">出入钻石会所 (限指定游轮) <sup>7</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">优先离船</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">专属钻石之夜活动 <sup>6</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">每日早餐搭配特色咖啡 <sup>7</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">娱乐之旅 <sup>8</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">幕后探秘 <sup>8</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">个性化礼品（每个家庭一份） <sup>9</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">出入贵宾休息室<br>（限指定游轮） <sup>14</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" s:class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td" style="display: block; padding-top: 5px;">剧院、冰上演出、水上剧院<br>等优先安排座位 <sup class="sup">10</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td  benefit-m-td-block">里程在340及以上的会员，<br>可与高级船员共进午餐 <sup class="sup">2</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">里程在340及以上的会员，<br>浴室盥洗用品可升级</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">里程在340及以上的会员，<br>获赠奖励礼品(每个家庭一份) <sup class="sup">9</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">里程在525及以上的会员，获赠奖励礼品(每个家庭一份) <sup class="sup">9</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">尖峰俱乐部的个性化徽章</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel06" :class="{ active: isShow('6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">具有专享特权的尖峰俱乐部SeaPass<sup class="sup">®</sup>卡 <sup class="sup">19</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel06" :class="{ active: isShow('6')}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="benefit-m-box">
                        <div class="benefit-m-header" :class="{ active: openMenu[1]}" @click="changeOpenMenu(1)">
                            <div class="benefit-m-txt">行前礼遇</div>
                            <div class="benefit-m-arrow"></div>
                        </div>
                        <div class="benefit-m-table-box scroll-container infinite-scroll js-smartScroll" :style="menuHeight(1)">
                            <div class="benefit-m-table">
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">会员预订专享优惠 <sup>11</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">优先获取特惠信息、新产品和<br>新航线等资讯 <sup class="sup">12</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td2 benefit-m-td-block" style="height: 100px;">与Celebrity Cruises®船长俱乐部（Captain’sClub）和Azamara Club Cruises®航海俱乐部（LeClub Voyage）相应等级会员享受相同待遇 <sup class="sup">17</sup></div>
                                    <div class="benefit-m-td benefit-m-td2" style="height: 100px;">
                                        <div class="benefit-m-hook jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">主餐厅用餐时间申请优先</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td3">出行前通过www.RoyalCaribbean.com/cas选择额外礼物</div>
                                    <div class="benefit-m-td benefit-m-td3">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td3 benefit-m-td-block">里程在340及以上的会员<br>可享受以单人船票费用150%的价格入住双人房型 <sup class="sup">15</sup></div>
                                    <div class="benefit-m-td benefit-m-td3">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td3 benefit-m-td-block">里程在700和1050的会员<br>可获得高达7晚的阳台房航行作为奖励航次（每个家庭一次）<sup class="sup">16</sup></div>
                                    <div class="benefit-m-td benefit-m-td3">
                                        <div class="benefit-m-hook jsLevel06" :class="{ active: isShow('6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td2 benefit-m-td-block">里程在1400（及之后每满350分）的会员可获得高至标准套房的航行作为奖励航次（每个家庭一次）<sup class="sup">16</sup></div>
                                    <div class="benefit-m-td benefit-m-td2">
                                        <div class="benefit-m-hook jsLevel06" :class="{ active: isShow('6')}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="benefit-m-box">
                        <div class="benefit-m-header" :class="{ active: openMenu[2]}" @click="changeOpenMenu(2)">
                            <div class="benefit-m-txt">更多礼遇</div>
                            <div class="benefit-m-arrow"></div>
                        </div>
                        <div class="benefit-m-table-box scroll-container infinite-scroll js-smartScroll" :style="menuHeight(2)">
                            <div class="benefit-m-table">
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">按优惠费率升舱<br>（视实际情况而定） <sup class="sup">18</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">订购套房获或单人入住双人房型享额外积分 <sup class="sup">13</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">会员航次（视实际情况而定）</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">皇冠铁锚俱乐部专属咨询热线</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">优先升舱 (视实际情况而定) <sup>18</sup></div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel05 jsLevel06" :class="{ active: isShow('5,6')}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="benefit-m-box">
                        <div class="benefit-m-header" :class="{ active: openMenu[3]}" @click="changeOpenMenu(3)">
                            <div class="benefit-m-txt">青少年礼遇</div>
                            <div class="benefit-m-arrow"></div>
                        </div>
                        <div class="benefit-m-table-box scroll-container infinite-scroll js-smartScroll" :style="menuHeight(3)">
                            <div class="benefit-m-table">
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td benefit-m-td-block">加载于SeaPass<sup>®</sup>卡中的船上优惠</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">纪念礼品</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel04 jsLevel05 jsLevel06" :class="{ active: isShow('4,5,6')}"></div>
                                    </div>
                                </div>
                                <div class="benefit-m-tr">
                                    <div class="benefit-m-td">儿童完成首次巡游后可获得与其家长相同的会员等级</div>
                                    <div class="benefit-m-td">
                                        <div class="benefit-m-hook jsLevel01 jsLevel02 jsLevel03 jsLevel04 jsLevel05" :class="{ active: isShow('1,2,3,4,5,6')}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="terms"  v-if="isShowVipTab">
                    <div class="terms-header">
                        <div class="terms-txt">通用条款与条件</div>
                        <div class="terms-arrow"></div>
                    </div>

                    <div class="scroll-container infinite-scroll js-smartScroll">
                        <div class="terms-body">
                            <p> 成为皇冠铁锚俱乐部会员，您每一次的航行都将获得相应的里程。您航行的每一晚都将获得1里程，如果预订套房，您的里程还将翻倍。</p>
                            <p><sup>1</sup> 视码头的实际情况而定。 <br> 2020年香港启德邮轮码头将为黄金（Gold）及以上级别的会员提供优先Check-in及优先登船服务；上海吴淞国际邮轮港、天津国际邮轮母港、深圳蛇口太子湾邮轮母港仅为白金(Platinum)及以上级别的会员提供优先Check-in及优先登船服务。</p>
                            <p><sup>2</sup> 与船上高级官员共进午餐仅适用于7晚及以上的航程。里程在340里程及以上的会员，每个航程仅有一次与船上高级官员共进午餐的机会。</p>
                            <p><sup>3</sup> 船上专用浴袍可根据您的需求发放。</p>
                            <p><sup>4</sup> 当您在航程中里程达到140、210、280与 350时，我们会为您赠送一份纪念礼品；且您在此后每获得70个里程积分都可获赠纪念礼品。每个“会员关联”仅可获得一份礼品。如会员在登船时放弃接受该礼品，航程结束后礼品将不再另行邮寄给会员。</p>
                            <p><sup>5</sup> 翡翠、钻石、超级钻石与尖峰俱乐部会员在航程第一天将会收到欢迎礼品，欢迎礼品包括点心和瓶装水等，将放置于顾客的舱房内。上述级别的会员可以联系当地客服人员，在饮品清单中预先挑选饮品并加入欢迎礼品中。18周岁及以上的会员每人可以选择一份饮品。会员必须在开航前数天（美国出发航次为5天，其他国家出发航次为7天）前提交饮品选择。翡翠和钻石会员的饮品清单将包含水、果汁和苏打水等；超级钻石和尖峰俱乐部会员的选择清单在上述基础上有所增加。如果乘客没有选择任何饮品，我们会提供一份瓶装水。精选酒类品牌可能会更换，视实际情况而定。</p>
                            <p><sup>6</sup> 专属钻石之夜活动（Exclusive Nightly Diamond Event）只对钻石、超级钻石与尖峰俱乐部会员开放，并且因空间有限将不对其朋友和家人开放。活动通常于17:00-20:00举行（视实际情况而定）。三张钻石之夜饮品礼券将会放入您的船卡，全程可使用。</p>
                            <p><sup>7</sup> 钻石会所是属于钻石、超级钻石与尖峰俱乐部会员的专属权益，并且因空间有限将不对其朋友和家人开放。免费特色咖啡仅在餐厅有早餐供应的时间提供。设有钻石会所的游轮将不举行专属钻石之夜活动，且餐厅不提供免费特色咖啡。钻石会所为禁烟场所。请乘客在参加会所活动时遵守时尚休闲着装要求（场内禁止穿着泳衣、拖鞋）。21岁以下的乘客必须全程由父母或监护人陪同。</p>
                            <p><sup>8</sup> 娱乐之旅（Entertainment tour）仅对钻石及以上级别的会员开放。对超级钻石以及尖峰俱乐部会员开放的幕后探秘（Behind the Scenes Tours）仅限5晚及以上的航程开放，内容包括参观厨房、船桥、以及含VIP剧院体验的升级娱乐之旅等。皇家加勒比国际游轮在法律允许范围内保有取消以上活动的权利（例如出于安全考虑等）。</p>
                            <p><sup>9</sup> 对于少于3晚的航程，将不会发放奖励礼品。对于3-6晚的航程，仅发放一份礼品。礼品选择需至少在开航前10天提交。如在规定的时间内没有完成礼品选择，您将不会收到任何奖励礼品。在登船当天或登船以后不能再进行礼品选择和/或更换。每个家庭仅可享受一份礼品。</p>
                            <p><sup>10</sup> 限指定游轮，视实际情况而定，需提前预定。剧院、冰上表演和水上剧院的优先座位将为您保留至开场前10分钟。</p>
                            <p><sup>11</sup> 皇冠铁锚俱乐部会员预订专属价格适用于指定游轮和航次。预定时必须提供有效的皇冠铁锚俱乐部里程号和适用的优惠代码。根据实际情况，优惠有可能变更或取消。如相应的凭证丢失、被盗用或损毁将无法享受该优惠。该优惠将不能用于某些特定费用。同一个预订只能使用一个优惠。该优惠不可与MyCruiseSM奖励、升舱、同伴票价、免费船票和旅行社优惠等叠加。除有特殊说明外，该优惠可用于所有级别的舱房。除有特殊说明外，该优惠将不可与其他促销或优惠同享。符合条件的优惠金额将在最终付款时予以扣除。该折扣将以每舱为基础，适用于至少2人入住的舱房。单人支付200%票价的会员可以享受全额面值优惠。根据游轮与航行日期不同，票价有所不同；客舱空间视您预订时的实际情况而定。优惠凭证需在最终付费之前或者优惠券到期之前使用，以时间先到的为准。</p>
                            <p><sup>12</sup> 为获得专属优惠或活动通知，您必须在皇冠铁锚俱乐部留下有效的手机号码及电子邮件地址。优惠活动因游轮、航次而不同。</p>
                            <p><sup>13</sup> 每完成一晚航程，可获得一里程；入住套房（房间类别包含RL,RS, PS,SL,TS,A1, A2,A3,CL, OS, FS, GS, JS）或单人以200%费用入住任何级别房间的航程，每晚可多积一里程。其他折扣，包括旅行社折扣，都不适用于单人入住享额外里程活动。里程将按照实际支付价格而非标注价格计算，例如，从套房以下级别的舱房以优惠费率升级至套房将无法享受额外里程。正常情况下，如您在预订时输入了正确的里程号，里程将在离船日起30天内自动累加到您的里程号中。2018年4月1日起，缺失里程补录的申请必须在您离船日起12个月内提交，逾期将不予补录。如您对您的会员账号或里程有任何疑问可联系当地客服人员处理。</p>
                            <p><sup>14</sup> 仅限指定游轮。贵宾休息室为禁烟区域。请乘客在贵宾休息室时遵守时尚休闲着装要求（场内禁止穿着泳装、拖鞋等）。21周岁以下乘客必须由家长或监护人全程陪同。由于空间有限，贵宾休息室将不对套房乘客、超级钻石和尖峰俱乐部会员的宾客和朋友开放。</p>
                            <p><sup>15</sup> 会员里程必须在340里程以上方可享受以单人船票价格150%的价格入住双人房型，假期航次（圣诞、新年等）及暑期航次等除外，视实际情况而定。</p>
                            <p><sup>16</sup> 励旅行以家庭为单位，基于双人入住房型，适用于满700, 1050, 1400, 1750, 2100里程（之后每增加350里程）的航程或上述里程到达后的下一次航程，逾期将作废。航程不包含港务税费、机票和/或往返港口的费用及个人支出（包括但不限于岸上观光费用、小费、某些食物与饮料费用、拍照费、服务费、医疗费等）。奖励航程包含游轮住宿、海上交通、大部分食物、某些饮料以及船上大部分娱乐活动。该福利适用于1）里程在700或1050里程时可享受最高7晚的加勒比航次的阳台房型（船票费用超出$2,400的部分需由乘客自行支付）；2）里程在1400里程及以上时可享受最高7晚的加勒比航程的标准套房房型（船票费用超出$3,200的部分需由乘客自行支付）。优惠视实际情况而定。具体航程和航行日期将由皇家加勒比游轮船务（中国）有限公司全权决定。奖励航程不可指派和转让，不能赠与、置换、出售或兑换现金。航程不可升级，也不可由其他皇冠铁锚俱乐部会员代替出行。奖励航程须遵守皇家加勒比游轮船务（中国）有限公司乘客船票旅行合同的条款和条件。该福利可随时取消，并且不可与其他优惠叠加使用。旅行社佣金不适用于奖励航次。优惠不适用于任何游轮的第一年航行和假期航次等。</p>
                            <p><sup>17</sup> “会员共享项目”可使皇冠铁锚俱乐部（Crown &amp; Anchor）、船长俱乐部（Captain’s Club）、航行俱乐部(Le Club Voyage)的会员在以上三个品牌的任一品牌下航行时获得相应的会员身份认可和福利待遇，包括与其会员级别对应的行前及船上待遇；但里程将仍然按照皇冠铁锚俱乐部里程累积规则根据实际航行情况进行累积。一个俱乐部的会员必须在上述的另一个俱乐部注册才可获得同等的会员福利。某一俱乐部中获得的里程不可与另一俱乐部的里程合并。皇冠铁锚俱乐部、船长俱乐部和航行俱乐部的福利是独立的不可叠加。 皇家加勒比皇冠铁锚俱乐部白金（Platinum）和翡翠(Emerald)级别等同于Celebrity游轮船长俱乐部的精选（Select）级别和Azamara Club游轮航行俱乐部的探险者(Explorer)级别。皇家加勒比皇冠铁锚俱乐部钻石(Diamond)、超级钻石(Diamond Plus)、尖峰俱乐部（Pinnacle Club）级别等同于Celebrity游轮船长俱乐部的精英（Elite）级别和Azamara Club游轮航行俱乐部的发现者（Discoverer）级别。尖峰俱乐部(Pinnacle Club)级别仅可通过在皇家加勒游轮上获得足够的里程后达到。</p>
                            <p><sup>18</sup> 在条件允许时，超级钻石(Diamond Plus)和尖峰俱乐部(Pinnacle Club)级别会员将有机会享受按优惠费率付费升舱。请在获得客舱升级资格之后提供您的升级偏好，我们会将您的偏好纳入考虑。客舱升级将根据实际情况进行调整，皇家加勒比游轮船务（中国）有限公司对于升舱机会或者升级偏好不做任何担保。</p>
                            <p><sup>19</sup> 尖峰俱乐部(Pinnacle Club)级别会员将享受专属礼遇。套房休息室仅适用于尖峰俱乐部会员和入住套房的宾客。</p>
                            <p style="font-size: 14px; font-weight: bold;">皇冠铁锚俱乐部升舱政策</p>
                            <p>我们的游轮通常会满载航行，因此升舱机会有限。当条件充足时，皇家加勒比游轮船务（中国）有限公司有权根据实际情况为超级钻石（Diamond Plus）和尖峰俱乐部（Pinnacle Club.）级别会员安排升舱。升舱名额将依据会员级别、会员里程、支付的舱房类别、预订时间等因素综合考虑。</p>
                            <p>为使您的升舱需求被纳入考虑，请确保：</p>
                            <p>1）您在订单中输入了正确的里程号、姓名、邮箱地址、电话号码等信息；</p>
                            <p>2）联系当地客服人员提交您的升舱偏好；我们将通过您在预订时预留的邮箱地址与您沟通升舱安排。在会员获得升舱资格之后如有特殊情况发生，皇家加勒比游轮船务（中国）有限公司将在法律允许范围内保留取消会员升舱的权利以满足其他客人的出行计划。</p>
                            <p style="font-size: 14px; font-weight: bold;">通用条款与条件</p>
                            <p>皇家加勒比游轮船务（中国）有限公司将根据实际情况，在法律允许范围内终止皇冠铁锚俱乐部（Crown &amp; Anchor Society® Program）（以下简称“俱乐部”）或不定期更新会员权益和相关的解释条款。所有的更新信息将通过皇家加勒比游轮中国官网进行公示，最新的会员权益和相关解释条款以皇家加勒比游轮中国官网会员页面信息为准。一旦任何人以与俱乐部条款、规定或宗旨相悖的方式利用该俱乐部利益，皇家加勒比游轮船务（中国）有限公司将在法律允许范围内保有决定权，其会员资格可能被终止。通过皇家加勒比游轮船务（中国）有限公司官方渠道（如中国官网、微信平台等）可免费注册为皇冠铁锚俱乐部会员，黄金及以上级别的会员必须参加过至少一次符合条件的皇家加勒比游轮航行。会员级别累加以每位会员获得的符合资格的游轮里程为基础。里程将在每次航行结束后累加。如果您在本航程中累积的里程恰好让您在本航程中升至更高的会员级别，您将从下一航程开始享受更高级别的会员权益。</p>
                            <p>皇冠铁锚俱乐部会员完成一次航行后，即可成为“黄金会员”；拥有30里程后可成为“白金会员”；拥有55里程后可成为“翡翠会员”；拥有80里程后可成为“钻石会员”；拥有175里程后可成为“超级钻石会员”；拥有700里程或更多里程后可成为“尖峰俱乐部会员”。</p>
                            <p>完成符合资格的旅行航程即可获得里程，里程基于支付的游轮客舱级别有所不同。奖励航程、优惠活动和/或优惠费率升舱（如从较低客舱级别以折扣价格升级至套房级别）将不会获得额外里程。里程仅适用于预订时正确录入姓名并且完成航行的客人。符合资格的游轮旅行不包括所有折扣票价旅行（例如员工/员工家属价格、供应商价格等）、旅行社折扣、以及皇家加勒比游轮船务（中国）有限公司指定的其他旅行活动。所有关于该俱乐部的资格或者权益条款的疑问或争议，皇家加勒比游轮船务（中国）有限公司将在法律范围内拥有解释和处理权利。本条款中提及的各项服务并非在皇家加勒比游轮船务（中国）有限公司旗下所有游轮均可提供。对于未能提供的服务，我们不承担退款或者损害赔偿责任。俱乐部所有折扣券均须遵循本条款规定以及折扣或优惠券上所描述的条款和条件。里程优惠活动不可叠加。如果一段航程适用于两种或多种里程优惠活动，将对各优惠活动进行评估，并给予乘客可享受的最佳优惠。一旦会员手机号码，邮箱地址，或者邮寄地址发生变更，会员有义务及时通知皇冠铁锚俱乐部，对于个人信息错误导致的信息错误发送、邮件误寄或由此产生的后果，皇家加勒比游轮船务（中国）有限公司将不承担任何责任。如某规定与法律冲突，则该条款无效。</p>
                            <p>皇冠铁锚俱乐部会员与家庭中的其他成员可形成“会员关联”且享有同等会员身份；但里程仍然按照会员实际参加的航行次数并以上述里程累加机制计算。家长和/或监护人的尖峰俱乐部会员身份不适用于其子女。只有会员本人、配偶或重要伴侣的其中一人在皇冠铁锚俱乐部中积满700里程或更多里程时，他们才可被视为尖峰俱乐部会员级别。</p>
                            <p>除尖峰俱乐部级别以外，其他级别的“会员关联”成员可包含配偶或重要伴侣以及不满18周岁的子女。对于尖峰俱乐部级别，“会员关联”成员仅包含配偶和/或重要伴侣。子女从18周岁生日当天起将被解除与父母/监护人的“会员关联”。如果发现子女在18周岁生日当天未被解除“会员关联”，并在此期间获得更高身份级别，其里程记录和级别将被调整为适当的会员级别。</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import {jumpOnlineService} from "@/utilities/common";
export default {
    name: "Cas",
    data() {
        return {
            currentLevel: 0,
            openMenu: [true, false, false, false],
            credit: 0,
            isShowVipTab:true
        }
    },
    mounted() {
        this.$store.commit('SET_PAGE_TITLE', '')
        const userToken = this.$store.state.user.userToken
        if (!userToken || userToken.length == 0) {
            return this.$router.push({ name: 'Login', query:{
                returnUrl: location.href
            }})
        }
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})

        this.initPage()
    },
    beforeDestroy() {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        async initPage () {
            this.$loading.show()
            const { success, data } = await api.user.refreshCas()
            this.$loading.hide()
            if (success && data && data.memberCredit.length > 0) {
                let userInfo = this.$store.state.user.userInfo
                userInfo.casCredit = data.memberCredit
                this.$store.commit('SET_USER_INFO', {userInfo})
                let credit = parseInt(data.memberCredit)
                if (!isNaN(credit)) {
                    if (credit < 3) {
                        this.currentLevel = 0
                    } else if (credit >= 3 && credit < 30) {
                        this.currentLevel = 1
                    } else if (credit >= 30 && credit < 55) {
                        this.currentLevel = 2
                    } else if (credit >= 55 && credit < 80) {
                        this.currentLevel = 3
                    } else if (credit >= 80 && credit < 175) {
                        this.currentLevel = 4
                    } else if (credit >= 175 && credit < 700) {
                        this.currentLevel = 5
                    } else if (credit >= 700){
                        this.currentLevel = 6
                    }
                }
            }
        },
        isShow (levels) {
            return levels.indexOf(this.currentLevel) >= 0
        },
        changeOpenMenu (index) {
            this.$set(this.openMenu, index, !this.openMenu[index])
        },
        menuHeight (index) {
            return this.openMenu[index] ? { 'max-height': '280px'}  : { 'max-height': '0px'}
        },
        goBack () {
            const query = this.$router.currentRoute.query
            if (query.returnUrl && query.returnUrl.length > 0) {
                return location.href = query.returnUrl
            }
            return this.$router.push('/Rccl.UserCenter/CustomerInfo/Info')
        },
        // 联系在线客服
        showOnlineService() {
          // window.open('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221', 'newwindow', 'height=400, width=400');
          // _hmt.push(['_trackEvent', 'Customer_Service', 'Click', 'top', 1]);
          jumpOnlineService();
        }
    },
    computed: {
        casId () {
            const userInfo = this.$store.state.user.userInfo
            if (userInfo && userInfo.casId) return userInfo.casId
            return ''
        },
        casCredit () {
            const userInfo = this.$store.state.user.userInfo
            if (userInfo && userInfo.casCredit) return userInfo.casCredit
            return ''
        },
        memberTitle () {
            switch (this.currentLevel){
                case 0: return '普通会员'
                case 1: return '黄金会员'
                case 2: return '白金会员'
                case 3: return '翡翠会员'
                case 4: return '钻石会员'
                case 5: return '超级钻石会员'
                case 6: return '尖峰俱乐部会员'
                default: return ''
            }
        }
    }
}
</script>

<style lang="less" scoped>
*{
    margin: 0;
    padding:0;
    list-style: none;
}
body{
    background: #fff;
    overflow-y:scroll;
}
#casBenefitPage nav.home-bar-nav {
    position: fixed;
    display: flex;
    background: url("https://resource.rcclchina.com.cn/memberCenter/mobile/cas-nav.png") 0% 0%/100% no-repeat;
    background-size: 100%;
}
.home-bar-nav .pull-left img{
    width: 14px;
}


.white-box {
    margin-bottom: 10px;
    background-color: #fff;
    border-bottom: 1px solid #e2e2e2;
}

.line-title {
    position: relative;
    width: 350px;
    padding-top: 20px;
    padding-bottom: 15px;
    margin-left: auto;
    margin-right: auto;
    font-size: 13px;
    line-height: 1;
    color: #061556;
    font-weight: bold;
    text-align: center;
}

    .line-title span {
        position: relative;
        z-index: 2;
        display: inline-block;
        padding: 0 10px;
        background-color: #fff;
    }

    .line-title::after {
        content: '';
        position: absolute;
        left: 0;
        top: 54%;
        display: block;
        width: 100%;
        height: 1px;
        background-color: #fab911;
    }

.yellow-btn {
    display: block;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    background: #fab911;
    font-size: 13px;
    line-height: 35px;
    color: #fff;
    text-align: center;
}

sup {
    font-size: 8px;
    position: relative;
    margin-left: 2px;
}

.sup {
    font-size: 8px;
    position: relative;
    top: -5px;
}

#casBenefitPage .page-content {
    touch-action: initial !important;
    background: #fff;
    top: -50px;
}

.mobileBenefit img {
    max-width: 100%;
    vertical-align: middle;
}

.mobileBenefit .memberBenefit {
    margin-top: 44px;
    padding-bottom: 8px;
}

.memberBenefit .line-title {
    padding-top: 13px;
}

    .memberBenefit .line-title::after {
        top: 48%;
    }

.memberBenefit .memberBenefit-txt {
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 22px;
    color: #333333;
    text-align: center;
}

.memberBenefit .yellow-btn {
    margin-bottom: 17px;
}

.memberBenefit .level-box {
    height: 128px;
    margin-bottom: 5px;
}

.level-tab {
    display: flex;
    justify-content: space-between;
    width: 351px;
    height: 128px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
}

.level-tab2 {
    position: fixed;
    left: 12px;
    top: 44px;
    z-index: 2100;
    /*transition: top 0.1s;*/
}

.level-tab img {
    max-width: 100%;
    vertical-align: middle;
}

.level-tab-cell {
    width: 48px;
}

.level-tab-txt {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    font-size: 11px;
    line-height: 14px;
    color: #989898;
    text-align: center;
}

.level-tab-cell.active {
    width: 60px;
}

.active .level-tab-txt {
    height: 32px;
    font-size: 13px;
    color: #061556;
}

.memberBenefit .benefit-m {
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 12px;
    border-bottom: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-box:first-child .benefit-m-header {
    border-top: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #0073a5;
    border-left: 1px solid #b9b9b9;
    border-right: 1px solid #b9b9b9;
    border-bottom: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-txt {
    font-size: 13px;
    line-height: 1;
    color: #fff;
}

.memberBenefit .benefit-m-arrow {
    width: 8px;
    height: 8px;
    -webkit-transform: rotateZ(-45deg);
    transform: rotateZ(-45deg);
    border-right: 1px solid #fab911;
    border-bottom: 1px solid #fab911;
}

.memberBenefit .active .benefit-m-arrow {
    -webkit-transform: rotateZ(45deg);
    transform: rotateZ(45deg);
}

.memberBenefit .benefit-m-table {
    border-top: 1px solid #b9b9b9;
    border-left: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-tr {
    display: flex;
}

.memberBenefit .benefit-m-td {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 45px;
    border-bottom: 1px solid #b9b9b9;
    border-right: 1px solid #b9b9b9;
    font-size: 11px;
    line-height: 18px;
    color: #333333;
    text-align: center;
}

.memberBenefit .benefit-m-td2 {
    height: 80px;
}

.memberBenefit .benefit-m-td3 {
    height: 70px;
}

.memberBenefit .benefit-m-td-block {
    display: block;
    padding-top: 5px;
}

.memberBenefit .benefit-m-hook {
    display: none;
    width: 7px;
    height: 14px;
    border-bottom: 1px solid #0073a5;
    border-right: 1px solid #0073a5;
    -webkit-transform: rotateZ(35deg);
    transform: rotateZ(35deg);
}

.memberBenefit .benefit-m-hook.active {
    display: block;
}

.memberBenefit .terms-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 350px;
    height: 35px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 4px;
    padding-right: 12px;
    border-bottom: 1px solid #b9b9b9;
    font-size: 11px;
    color: #1a1a1a;
}

.memberBenefit .terms-arrow {
    width: 8px;
    height: 8px;
    -webkit-transform: rotateZ(-45deg);
    transform: rotateZ(-45deg);
    border-right: 1px solid #1a1a1a;
    border-bottom: 1px solid #1a1a1a;
}

.memberBenefit .active .terms-arrow {
    -webkit-transform: rotateZ(45deg);
    transform: rotateZ(45deg);
}

.memberBenefit .terms-body {
    margin: 0px 16px;
    font-size: 12px;
    display: none;
}

#mobileBenefit {
    overflow: hidden;
    height: 100%;
}

.mobileBenefit .recommend {
    padding-bottom: 100px;
}

.mobileBenefit .recommend-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
}

.mobileBenefit .recommend-box {
    width: 173px;
    margin-bottom: 10px;
}

.mobileBenefit .recommend-box-media {
    position: relative;
    height: 76px;
    font-size: 9px;
    line-height: 1;
    color: #fff;
    text-align: center;
    background-size: 100%;
}

.mobileBenefit .recommend-box-inner {
    height: 100%;
    padding-top: 14px;
    background-color: rgba(0,0,0,.4);
}

.mobileBenefit .recommend-box-media .longLine {
    position: absolute;
    top: 0;
    right: 5px;
    width: 48px;
}

.mobileBenefit .recommend-box-media .longLine-txt {
    position: absolute;
    left: -25%;
    top: -1px;
    width: 150%;
    font-size: 13px;
    color: #fff;
    text-align: center;
}

    .mobileBenefit .recommend-box-media .longLine-txt span {
        display: block;
        -webkit-transform: scale(.6);
        transform: scale(.6);
    }

.mobileBenefit .recommend-box-media p {
    margin: 0 0 3px 0;
}

.mobileBenefit .recommend-box-media .txt01 {
    font-weight: bold;
}

.mobileBenefit .recommend-box-media .txt02 {
    font-size: 12px;
    font-weight: bold;
}

.mobileBenefit .recommend-box-btn {
    height: 27px;
    background: #fab911;
    font-size: 13px;
    line-height: 27px;
    color: #000d57;
    text-align: center;
}



.mobileBenefit img {
    max-width: 100%;
    vertical-align: middle;
}

.mobileBenefit .memberBenefit {
    margin-top: 44px;
    padding-bottom: 8px;
}

.memberBenefit .line-title {
    padding-top: 13px;
}

    .memberBenefit .line-title::after {
        top: 48%;
    }

.memberBenefit .memberBenefit-txt {
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 22px;
    color: #333333;
    text-align: center;
}

.memberBenefit .yellow-btn {
    margin-bottom: 17px;
}

.memberBenefit .level-box {
    height: 128px;
    margin-bottom: 5px;
}

.memberBenefit .level-tab {
    display: flex;
    justify-content: space-between;
    width: 350px;
    height: 128px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
}

.memberBenefit .level-tab2 {
    position: absolute;
    left: 12px;
    z-index: 10;
    transition: top 0.1s;
}

.memberBenefit .level-tab-cell {
    width: 48px;
}

.memberBenefit .level-tab-txt {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    font-size: 11px;
    line-height: 14px;
    color: #989898;
    text-align: center;
}

.memberBenefit .level-tab-cell.active {
    width: 60px;
}

.memberBenefit .active .level-tab-txt {
    height: 32px;
    font-size: 13px;
    color: #061556;
}

.memberBenefit .benefit-m {
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 12px;
    border-bottom: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-box:first-child .benefit-m-header {
    border-top: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #0073a5;
    border-left: 1px solid #b9b9b9;
    border-right: 1px solid #b9b9b9;
    border-bottom: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-txt {
    font-size: 13px;
    line-height: 1;
    color: #fff;
}

.memberBenefit .benefit-m-arrow {
    width: 8px;
    height: 8px;
    transform: rotateZ(-45deg);
    border-right: 1px solid #fab911;
    border-bottom: 1px solid #fab911;
}

.memberBenefit .active .benefit-m-arrow {
    transform: rotateZ(45deg);
}

.memberBenefit .benefit-m-table-box {
    display: block;
    max-height: 0px;
    overflow-y: scroll !important;
    transition: all 0.3s;
}

.memberBenefit .benefit-m-table {
    border-top: 1px solid #b9b9b9;
    border-left: 1px solid #b9b9b9;
}

.memberBenefit .benefit-m-tr {
    display: flex;
}

.memberBenefit .benefit-m-td {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 35px;
    border-bottom: 1px solid #b9b9b9;
    border-right: 1px solid #b9b9b9;
    font-size: 11px;
    line-height: 12px;
    color: #333333;
    text-align: center;
}

.memberBenefit .benefit-m-td2 {
    height: 80px;
}

.memberBenefit .benefit-m-td3 {
    height: 50px;
}

.memberBenefit .benefit-m-hook {
    display: none;
    width: 7px;
    height: 14px;
    border-bottom: 1px solid #0073a5;
    border-right: 1px solid #0073a5;
    transform: rotateZ(35deg);
}

.memberBenefit .terms {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 350px;
    height: 35px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 4px;
    padding-right: 12px;
    border-bottom: 1px solid #b9b9b9;
    font-size: 11px;
    color: #1a1a1a;
}

.memberBenefit .terms-arrow {
    width: 8px;
    height: 8px;
    transform: rotateZ(-45deg);
    border-right: 1px solid #1a1a1a;
    border-bottom: 1px solid #1a1a1a;
}




.mobileBenefit .recommend {
    padding-bottom: 54px;
}

.mobileBenefit .recommend-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
}

.mobileBenefit .recommend-box {
    width: 173px;
    margin-bottom: 10px;
}

.mobileBenefit .recommend-box-media {
    position: relative;
    height: 76px;
    padding-top: 14px;
    font-size: 9px;
    line-height: 1;
    color: #fff;
    text-align: center;
    background-size: 100%;
}

    .mobileBenefit .recommend-box-media .longLine {
        position: absolute;
        top: 0;
        right: 5px;
        width: 44px;
    }

    .mobileBenefit .recommend-box-media p {
        margin: 0 0 3px 0;
    }

    .mobileBenefit .recommend-box-media .txt01 {
        font-weight: bold;
    }

    .mobileBenefit .recommend-box-media .txt02 {
        font-size: 12px;
        font-weight: bold;
    }

.mobileBenefit .recommend-box-btn {
    height: 27px;
    background: #fab911;
    font-size: 13px;
    line-height: 27px;
    color: #000d57;
    text-align: center;
}


/*
    在改文件基础改了的原有的样式
*/
.memberBenefit .terms {
    position: relative;
    height: 100%;
}

.memberBenefit .terms-header {
    position: absolute;
    top: 0;
}

.memberBenefit .terms-body {
    overflow: hidden;
    position: absolute;
    top: 51px;
}

.home-bar-nav .nav-title{
    margin-left: 10px;
}
.cas-header {
    text-align: center;
    font-size: 12px;
    color: #fff;
    overflow: hidden;
    line-height: 2;
    margin-bottom: 24px;
    padding: 20px 0px;
    background-image: -webkit-linear-gradient( 180deg, rgb(9,139,229) 0%, rgb(7,63,151) 100%);
}
.cas-header .cas-code{
   margin-top: 50px;
}
.cas-header .cas-notmember{
    margin-top: 50px;
}
.cas-header .cas-notmember a{
    display: inline-block;
    padding: 2px 17px;
    border-radius: 21px;
    border: 1px solid #fff;
    color: #fff;
}

.level-box{
    margin-bottom: 5px;
}

body .footer-nav {
    display: none;
}
.rcclPdf{
  width: 100%;
  height: 100vh;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
